module.exports = __webpack_public_path__ + "img/logo-active-bg.3401ddd5.svg";